import { render, staticRenderFns } from "./FidoBorsellino.vue?vue&type=template&id=3cd7603e&scoped=true"
import script from "./FidoBorsellino.vue?vue&type=script&lang=js"
export * from "./FidoBorsellino.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cd7603e",
  null
  
)

export default component.exports